import useFirstLoad from 'infra/events/useFirstLoad.hook';
import { useHandlerCompanyByRouter, useHandlerPropertyByRouter } from 'infra/routes/use-listen-router';
import { useGetPropertyBasicInfo } from 'querys/property/property.query';
import useLoadRegions from './utils/hooks/useLoadRegions';

const useCoreDataHandlers = () => {
  useFirstLoad();
  useHandlerCompanyByRouter();
  useHandlerPropertyByRouter();
  useLoadRegions();
  useGetPropertyBasicInfo();
};

export default useCoreDataHandlers;
